import { Select } from 'antd'
import React from 'react'

export default class DataUtil {
  //static row2col: (jsonData: any, idField: string, colField: string, valueField: string, emptyValue: string) => any[];
  // 数据纵列转换
  static row2col(jsonData: any, idField: string, colField: string, valueField: string, emptyValue: string) {
    let result: any[] = [], //存储返回的数据
      idIndexData: number[] = [], //存储id在数组中的信息(位置)
      resultColumns: string[] = [], //存储列名数据
      curRecord = null //存储当前数据

    let idFields = idField.split(',')
    //let colFields = colField.split(',');

    // 循环整个JSON数组：[{...},{...},{...},...]
    for (let idx = 0; idx < jsonData.length; idx++) {
      // 当前json数据对象
      let cdata = jsonData[idx]

      // 根据主键值，查找到结果数组中的索引号
      let idValue: any = ''
      for (let idf in idFields) {
        idValue += cdata[idFields[idf]]
      }
      let num = idIndexData[idValue] //获取存储该id的数组索引号
      if (num != null) {
        curRecord = result[num]
      } else {
        // 初始化数据时保持完整的结构信息 避免因为缺乏数据，缺乏指定的列数据
        curRecord = {}
      }

      // 指定的colFields列下的数据作为y轴，则取出该列的数据作为y轴即可
      // for (var i in colFields) {
      //     var key = colFields[i];

      // 获取到colField的值，作为列名
      var value = cdata[colField]
      curRecord[value] = cdata[valueField]

      // 存储列名
      if (resultColumns.indexOf(value) === -1) resultColumns.push(value)
      //     break;
      // }

      // 除数据内容外，还需要添加主键数据
      //curRecord[idField] = idValue;
      for (let idf in idFields) {
        curRecord[idFields[idf]] = cdata[idFields[idf]]
      }

      // 对象若为新建 则新增进数组
      if (num == null) {
        idIndexData[idValue] = result.push(curRecord) - 1
      }
    }

    // 数据检查 由于是将行数据作为列名，则可能会存在部分行缺少其他列数据，若缺少，则指定默认值
    for (var i2 in result) {
      for (var name in resultColumns) {
        if (!result[i2].hasOwnProperty(name)) result[i2][name] = emptyValue
      }
    }
    return { columns: resultColumns, data: result }
  }

  static findMaxMin(data: any, field: string) {
    try {
      let maxValue = data[0][field]
      let minValue = data[0][field]
      let maxObj = data[0]
      let minObj = data[0]
      for (const d of data) {
        if (d[field] > maxValue) {
          maxValue = d[field]
          maxObj = d
        }
        if (d[field] < minValue) {
          minValue = d[field]
          minObj = d
        }
      }
      return { max: maxObj, min: minObj }
    } catch {
      return { max: { [field]: 0 }, min: { [field]: 0 } }
    }
  }

  static selectOptionsRender = (arr: any[], code: string, name: string, excode?: string) => {
    const { Option } = Select
    return arr
      ? arr.map((item, index) => {
          return (
            <Option key={item[code]} value={item[code]} excode={excode ? item[excode] : ''}>
              {item[name]}
            </Option>
          )
        })
      : null
  }

  static treeDataClean = (data: any, titleField?: string, keyField?: string) => {
    const cleanData = (data: any) => {
      for (let i = 0; i < data.length; i++) {
        if (data[i].children && data[i].children.length === 0) {
          data[i].children = undefined
        } else if (data[i].children && data[i].children.length > 0) {
          data[i].children = cleanData(data[i].children)
        }
        if (titleField) {
          data[i].title = data[i][titleField]
        }
        if (keyField) {
          data[i].key = data[i][keyField]
        }
      }
      return data
    }
    let myData = cleanData(data)
    return myData
  }
}

export const myFlat = <T extends any[]>(arr: T): T => {
  const newArr = arr.reduce((total, cur) => total.concat(Array.isArray(cur.children) ? myFlat(cur.children) : cur), [])
  return newArr
}

/**
 * 将对象数组转成多维对象数组
 * @param arr 要转成多维数组的数组
 * @param selfIdField 自身 id 字段
 * @param parentIdField 父级 id 字段
 * @param childrenField 存放子元素的字段, 默认为 children
 * @returns 转换后的多维数组
 */
export const toMultiDimensionArr = (
  arr: { [x: string]: any }[],
  selfIdField: string,
  parentIdField: string,
  childrenField = 'children'
): { [x: string]: any }[] => {
  const data: typeof arr = JSON.parse(JSON.stringify(arr))
  data.forEach((item) => {
    const parent = data.find((res) => res[selfIdField] === item[parentIdField])
    if (parent) {
      parent[childrenField] = parent[childrenField] || []
      parent[childrenField].push(item)
    }
  })
  return data.filter((item) => item[selfIdField] && !item[parentIdField]) // 自身 id 存在, 且父级 id 不存在或者为 0
}
